import selectAccordion from './event/select-accordion'

(() => {
  selectAccordion();
})()
